import MonochromeTechThumbnailPath from '../../../assets/template-thumbnails/triangular/monochrome-triangular-template-thumbnail.png';

const MonochromeTechTemplate = {
    id: 'monochrome-tech-template',
    name: 'Monochrome',
    category: 'Triangular',
    settings: {
      layoutId: 'centered-header',
      designId: 'custom',
      style: 'tech',
      background: 'triangle',
      barStyleId: 'squares',
      specialEffectId: 'timeline',
      customColors: {
        primary: "#000000",
        secondary: "#333333",
        tertiary: "#555555",
        quaternary: "#777777",
        accent1: "#000000",
        accent2: "#000000",
        text: "#000000",
        textSecondary: "#555555",
        sidebarText: "#000000",
        sidebarPrimary: "#000000",
        background: "#ffffff",
        sidebarBackground: "#ffffff",
        border: "#cccccc"
      },
      typography: {
        cvTitle: { fontSize: 40, lineHeight: 1, fontFamily: "'Roboto', sans-serif" },
        sectionTitle: { fontSize: 11, lineHeight: 1.3, fontFamily: "'Roboto', sans-serif" },
        body: { fontSize: 9.5, lineHeight: 1, fontFamily: "'Roboto', sans-serif" },
        smallText: { fontSize: 8, lineHeight: 1.5, fontFamily: "'Roboto', sans-serif" },
      },
    },
    thumbnail: MonochromeTechThumbnailPath
  };

export default MonochromeTechTemplate; 